<span class="notification-box" translate>
	issue.draft.deleted
</span>